<template>
<div class="select-user">
  <el-dialog title="选择客户" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false" width="80vw">
    <div style="max-height: 700px;overflow-y: auto;">
      <room-user v-if="dialogVisible" ref="RoomUser" :house="house" />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirm()">确 定</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script>
import RoomUser from "./room-user";
export default {
  name: "ErpRoomUser",
  components: {RoomUser},
  data(){
    return {
      dialogVisible:false,
      house:"",
      callback:null,
    }
  },
  methods:{
    /**
     * 显示
     * @param callback
     * @param house_name
     */
    show(callback,house_name){
      this.house=house_name;
      this.dialogVisible=true;
      this.callback=callback
    },
    confirm(){
      typeof this.callback==="function"&&(this.callback(this.$refs.RoomUser.getUser()) , this.callback=undefined);
      this.dialogVisible=false;
    }
  }
}
</script>

<style lang="scss" scoped>
.select-user{
  >>>.el-dialog__body{
    padding-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/ErpRoomUser.vue